import * as React from 'react';
export const PKSvg = React.forwardRef(function PKSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M2 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h3v1H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3v1H2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#159570',
        d: 'M5 2v12h9.008c1.1 0 1.992-.902 1.992-2.009V4.01C16 2.899 15.1 2 14.008 2H5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M8.678 4.743a4.5 4.5 0 0 0 5.58 5.58 4 4 0 1 1-5.58-5.58ZM13 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z',
      }),
    ),
  );
});
PKSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var PK = {
  category: 'flag',
  colorable: false,
  name: 'PK',
  svg: PKSvg,
};
